// static/rewards-hub-app/src/common/components/SuccessAnimation.tsx
import React, { useState, useEffect } from 'react';
import ImageLottie from './ImageLottie';
import { fromPublic, cacheLottie } from '../../utils';

interface SuccessAnimationProps {
  show: boolean;
  animationPath?: string;
  onAnimationComplete?: () => void;
  autoHide?: boolean;
  autoHideDelay?: number;
}

const SuccessAnimation: React.FC<SuccessAnimationProps> = ({
  show,
  animationPath = '/custom/common/party.json',
  onAnimationComplete,
  autoHide = false,
  autoHideDelay = 3000
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [lottieKey, setLottieKey] = useState(0);

  useEffect(() => {
    if (animationPath) {
      cacheLottie(fromPublic(animationPath)).catch(err => 
        console.error(`Failed to preload animation: ${animationPath}`, err)
      );
    }
  }, [animationPath]);
  
  useEffect(() => {
    if (show) {
      setIsVisible(true);
      setLottieKey(prevKey => prevKey + 1);
      
      if (autoHide) {
        const timer = setTimeout(() => {
          setIsVisible(false);
          onAnimationComplete?.();
        }, autoHideDelay);
        
        return () => clearTimeout(timer);
      }
    } else {
      setIsVisible(false);
    }
  }, [show, autoHide, autoHideDelay, onAnimationComplete]);
  
  if (!isVisible || !animationPath) return null;
  
  return (
    <ImageLottie 
      key={lottieKey}
      imageLottie={animationPath}
      fullScreen={true}
      loop={false}
    />
  );
};

export default SuccessAnimation;